<template>
  <div>
    <el-dialog
      title="选择指定群组"
      :visible.sync="dialogVisible"
      :before-close="dialogBeforeClose"
      append-to-body
    >
      <div>
        <div class="label">
          所属群组
        </div>
        <el-cascader
          ref="cascader"
          v-model="groupId"
          :options="options"
          :props="{ checkStrictly: true, value: 'id', label: 'group_name' }"
          clearable
          style="width: 300px"
        />
      </div>
      <div slot="footer">
        <el-button @click="submitSpccifiedGroups(false)">
          忽 略
        </el-button>
        <el-button
          type="primary"
          @click="submitSpccifiedGroups(true)"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SpGroupsSelect',
  model: {
    prop: 'dialogVisible',
    event: 'dialogVisibleChange'
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      groupId: 0
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.getList()
      }
    }
  },
  methods: {
    // 获取群组列表
    async getList () {
      const data = await this.$api.organization.getGroupsList()
      if (data) {
        this.options = data.list
      }
    },

    // 选择群组
    submitSpccifiedGroups (type) {
      if (type) {
        let groupId = this.$refs.cascader.getCheckedNodes(true)
        this.$emit(
          'submitSpccifiedGroups',
          (groupId && groupId.length > 0 && groupId.map((v) => v.value)) || []
        )
      } else {
        this.$emit('submitSpccifiedGroups', [])
      }
    },

    dialogBeforeClose () {
      this.$emit('dialogVisibleChange', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  margin-bottom: 10px;
}
</style>
